export default __webpack_public_path__ + "static/81862-47dd6298293bc4dfcec0164b63bc8c5c.jpg";